export const pageStack = {
	state: {
    pageStack: [],
    isChangeBasicPage: false,    
    map: {
      
    },
	},
	mutations: {
    clearPageStack (state) {
      state.pageStack = []
    },

    pushPageToStack (state, page) {
      if (typeof page === 'object')  {
        state.pageStack.push(page)
      } else {
        throw new TypeError('the new Page is not a object')
      }
    },

    popPageInStack (state) {
      state.pageStack.length -= 1
    },
	},
	actions: {
    
	},
	getters: {
    pageStack (state) {
      return state.pageStack
    },
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/page-stack/index.js